exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirm{width:100%}.confirm .overlay{position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.35);z-index:20}.confirm .c-main{position:absolute;top:25%;left:0;right:0;z-index:30;width:80%;background-color:#fff;text-align:center;margin:0 auto;border-radius:.26666667rem}.confirm .c-main .close{font-size:.53333333rem;color:#ddd;display:block;position:absolute;right:.4rem;top:.4rem}.confirm .c-main img{width:6rem;padding-top:.53333333rem}.confirm .c-main p{font-size:.37333333rem;color:#999;margin-bottom:.53333333rem}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/vue-loader/lib/style-rewriter.js?id=data-v-34f6209f!../~/less-loader!../~/vue-loader/lib/selector.js?type=styles&index=0!./components/vue/confirm.vue
 ** module id = 127
 ** module chunks = 1 2
 **/